export function getBrowserType() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");

  if (isFirefox) {
    document.body.classList.add("firefox");
  }
  if (isSafari) {
    document.body.classList.add("safari");
  }
}
